import React from 'react';
import { Container, Value, Infinito } from './styles';
import { H3 } from '../../styles/stylesTypography';
import { theme } from '../../styles/theme';

const CircularGauge = ({ total = 0, restante = 0, ilimitado = false, size = 140, strokeWidth = 8 }) => {
    const percentUsado = !ilimitado && total > 0 ? ((total - restante) / total) * 100 : 0;

    // Mesma regra de cores da bolinha de créditos na home (nova-home/circle-data/GraphicCircle.js):
    // saldo >= 10 fica verde, entre 5 e 9 amarelo, abaixo de 5 vermelho.
    const cor = ilimitado
        ? theme.colors.green.Verde_AgroReceita
        : restante >= 10
            ? theme.colors.green.Verde_AgroReceita
            : restante >= 5
                ? theme.colors.yellow.Amarelo
                : theme.colors.red.Vermelho_erro;

    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = ilimitado ? 0 : circumference * (percentUsado / 100);

    return (
        <Container size={size}>
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={theme.colors.gray.Cinza_10}
                    strokeWidth={strokeWidth}
                />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={cor}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                />
            </svg>

            <Value>
                <H3>{ilimitado ? <Infinito>8</Infinito> : restante}</H3>
            </Value>
        </Container>
    );
};

export default CircularGauge;
